import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithInput.js";
import Features from "components/features/ThreeColWithSideImage.js";
// import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
// import FeatureWithSteps from "components/features/TwoColWithSteps.js";
// import Pricing from "components/pricing/ThreePlans.js";
// import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";
// import FAQ from "components/faqs/SingleCol.js";
import GetStarted from "components/cta/GetStarted";
import Footer from "components/footers/FiveColumnWithBackground.js";
// import heroScreenshotImageSrc from "images/hero-screenshot-1.png";
// import macHeroScreenshotImageSrc from "images/hero-screenshot-2.png";
import prototypeIllustrationImageSrc from "images/prototype-illustration.svg";
import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as UsersIcon } from "feather-icons/dist/icons/users.svg";
import { ReactComponent as LayersIcon } from "feather-icons/dist/icons/layers.svg";
import TrendingCards from "components/cards/TwoTrendingPreviewCardsWithImage.js";
// import Testimonial from "components/testimonials/SimplePrimaryBackground.js";

export default () => {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
  const HighlightedText = tw.span`text-primary-500`;

  return (
    <AnimationRevealPage>
      <Hero roundedHeaderButton={true} />
      <Features
        subheading={<Subheading>Services</Subheading>}
        heading={
          <>
            Our <HighlightedText>Services</HighlightedText>
          </>
        }
        description="End-to-end software development services tailored to your business goals — from concept to launch and beyond."
      />
      {/* <MainFeature
        subheading={<Subheading>Quality Work</Subheading>}
        imageSrc={heroScreenshotImageSrc}
        imageBorder={true}
        imageDecoratorBlob={true}
      /> */}
      {/* <FeatureWithSteps
        subheading={<Subheading>STEPS</Subheading>}
        heading={
          <>
            Easy to <HighlightedText>Get Started.</HighlightedText>
          </>
        }
        textOnLeft={false}
        imageSrc={macHeroScreenshotImageSrc}
        imageDecoratorBlob={true}
        decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-15 -translate-x-1/2 left-1/2`}
      /> */}
      <MainFeature2
        subheading={<Subheading>Why Us</Subheading>}
        heading={
          <>
            Why Choose <HighlightedText>Spurnest?</HighlightedText>
          </>
        }
        primaryButtonText="About Us"
        primaryButtonUrl="/aboutus"
        imageSrc={prototypeIllustrationImageSrc}
        showDecoratorBlob={false}
        features={[
          {
            Icon: MoneyIcon,
            title: "Affordable Pricing",
            description: "Transparent pricing with no hidden costs — quality software that fits your budget.",
            iconContainerCss: tw`bg-green-300 text-green-800`
          },
          {
            Icon: BriefcaseIcon,
            title: "Professionalism",
            description: "On-time delivery and clear communication at every stage of your project.",
            iconContainerCss: tw`bg-red-300 text-red-800`
          },
          {
            Icon: UsersIcon,
            title: "Client-First Approach",
            description: "We listen first, then build — your goals and feedback shape every decision we make.",
            iconContainerCss: tw`bg-blue-300 text-blue-800`
          },
          {
            Icon: LayersIcon,
            title: "End-to-End Ownership",
            description: "From design and development to deployment and support — we handle it all.",
            iconContainerCss: tw`bg-purple-300 text-purple-800`
          }
        ]}
      />
      <TrendingCards />
      {/* <Testimonial /> */}
      <GetStarted
        text="Ready to bring your idea to life?"
        primaryLinkText="Start Your Project"
        primaryLinkUrl="/contact-us"
        secondaryLinkText="Learn About Us"
        secondaryLinkUrl="/aboutus"
      />
      <Footer />
    </AnimationRevealPage>
  );
}
